import { render, staticRenderFns } from "./FeedAlertEdit.vue?vue&type=template&id=8ffd5f12"
import script from "./FeedAlertEdit.vue?vue&type=script&lang=js"
export * from "./FeedAlertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports